import { withTheme } from '../config';
import { FAB } from '@rneui/base/dist/FAB/FAB';
export { FAB };
export default withTheme(FAB, 'FAB');
